import { render, staticRenderFns } from "./PreviousNameYN.vue?vue&type=template&id=49765494"
import script from "./PreviousNameYN.vue?vue&type=script&lang=js"
export * from "./PreviousNameYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports